export default {
  ctaText: "Let's produce",
  headerLabel: "Available workers: ",
  sidePanelSubtitle: "Planning for the second batch.",
  sidePanelTitle: "Start producing!",
  title: "Second batch: Select the number of workers and which item to produce for each production line"
};
